// @flow

import React from 'react';

export default () => <div className="preloader active" />;
